// extracted by mini-css-extract-plugin
export default {"CreateRoleContent":"CreateRoleContent_CreateRoleContent__YONUK","PasswordRecuirements":"CreateRoleContent_PasswordRecuirements__m96hx"};